import api from '../utils/axios';

export interface Note {
  id: string;
  content: string;
  claimId: string;
  created_by: string;
  updated_by?: string;
  created_at: string | null;  // ISO string format from API
  updated_at: string | null;  // ISO string format from API
  creator?: {
    firstName: string;
    lastName: string;
  };
  updater?: {
    firstName: string;
    lastName: string;
  };
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

export const notesService = {
  async getNotesByClaimId(claimId: string): Promise<Note[]> {
    const response = await api.get<ApiResponse<Note[]>>(`/claims/${claimId}/notes`);
    return response.data.data;
  },

  async createNote(claimId: string, content: string): Promise<Note> {
    const response = await api.post<ApiResponse<Note>>(`/claims/${claimId}/notes`, { content });
    return response.data.data;
  },

  async updateNote(noteId: string, content: string): Promise<Note> {
    const response = await api.put<ApiResponse<Note>>(`/claims/${noteId}/notes/${noteId}`, { content });
    return response.data.data;
  },

  async deleteNote(noteId: string, claimId?: string): Promise<void> {
    const path = claimId ? `/claims/${claimId}/notes/${noteId}` : `/claims/notes/${noteId}`;
    await api.delete(path);
  }
}; 